<template>
  <div class="animated fadeIn">
    <b-row class="mb-4">
      <b-col lg="6">
        <!-- <b-card>
          <h3 class="text-shoppingCartGray">
            {{ campaign.campaign_report.CampaignHeader.Dealership.Name }}
          </h3>

          <h5>
            {{ campaign.campaign_report.CampaignHeader.Dealership.Address1 }}
            {{ campaign.campaign_report.CampaignHeader.Dealership.Address2 }}
          </h5>
          <h5>
            {{ campaign.campaign_report.CampaignHeader.Dealership.City }}
            {{ campaign.campaign_report.CampaignHeader.Dealership.State }}
            {{ campaign.campaign_report.CampaignHeader.Dealership.PostalCode }}
          </h5>
        </b-card> -->

        <div class="return-address">
          <p class="company-name">
            {{ campaign.campaign_report.CampaignHeader.Dealership.Name }}
          </p>
          <p class="address-line">
            {{ campaign.campaign_report.CampaignHeader.Dealership.Address1 }}
            {{ campaign.campaign_report.CampaignHeader.Dealership.Address2 }}
          </p>
          <p class="address-line">
            {{ campaign.campaign_report.CampaignHeader.Dealership.City }},
            {{ campaign.campaign_report.CampaignHeader.Dealership.State }}
            {{ campaign.campaign_report.CampaignHeader.Dealership.PostalCode }}
          </p>
        </div>
      </b-col>
      <b-col lg="6">
        <div class="return-address">
          <p class="company-name">
            PO # {{ campaign.campaign_report.CampaignHeader.PONumber }}
          </p>

          <p class="address-line">
            {{ campaign.campaign_report.CampaignHeader.campaign_name }}
          </p>
          <p class="address-line">
            Broadcast Date:
            {{ campaign.campaign_report.CampaignHeader.broadcast_date }}
          </p>
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col lg="3">
        <b-button variant="link" disabled
          ><h3 class="mb-4">
            Activity & Analytics
          </h3></b-button
        >
      </b-col>
      <b-col lg="3">
        <b-button variant="link" @click="loadOtherReport(2)"
          ><h3 class="mb-4">
            Performance & ROI
          </h3></b-button
        >
      </b-col>
      <b-col lg="3">
        <b-button variant="link" @click="loadOtherReport(3)"
          ><h3 class="mb-4">
            Summary & Charts
          </h3></b-button
        >
      </b-col>
      <b-col lg="3">
        <b-button
          variant="outline-primary"
          class="mt-2"
          v-if="n_user.n_current_user.IsSU && !isMatchBackFileCreated"
          active
          @click="createMatchBackFile"
        >
          Create Matchback File
        </b-button>
        <h5 v-if="n_user.n_current_user.IsSU && isMatchBackFileCreated">
          File is ready for download:
        </h5>
        <a
          target="_blank"
          v-if="n_user.n_current_user.IsSU && isMatchBackFileCreated"
          :href="matchBackFileLink"
          v-text="matchBackFileName"
        />
      </b-col>
    </b-row>
    <b-row>
      <b-col lg="12">
        <b-card>
          <b-row>
            <b-col lg="6">
              <h2>Emails</h2>
              <b-row class="mt-2">
                <b-col lg="6">
                  <h5>Unique Customers</h5>
                </b-col>
                <b-col lg="6">
                  <h5>
                    {{
                      with_comma(
                        campaign.campaign_report.CampaignHeader
                          .CustomersTargeted
                      )
                    }}
                  </h5>
                </b-col>
              </b-row>
              <b-row>
                <b-col lg="6">
                  <h5>Delivered</h5>
                </b-col>
                <b-col lg="6">
                  <h5>
                    {{
                      with_comma(
                        campaign.campaign_report.CampaignHeader.quantity
                      )
                    }}
                  </h5>
                </b-col>
              </b-row>
              <b-row>
                <b-col lg="6">
                  <h5>Opened</h5>
                </b-col>
                <b-col lg="6">
                  <h5>
                    {{
                      with_comma(campaign.campaign_report.CampaignHeader.opens)
                    }}
                  </h5>
                </b-col>
              </b-row>
              <b-row>
                <b-col lg="6">
                  <h5>Clicked</h5>
                </b-col>
                <b-col lg="6">
                  <h5>
                    {{
                      with_comma(campaign.campaign_report.CampaignHeader.clicks)
                    }}
                  </h5>
                </b-col>
              </b-row>
              <hr />
              <hr />
              <h2>Engagement Rates</h2>
              <b-row>
                <b-col lg="6">
                  <h5>Open Rate</h5>
                </b-col>
                <b-col lg="6">
                  <h5>
                    {{
                      as_percentage(
                        campaign.campaign_report.CampaignHeader.opens_pc
                      )
                    }}
                  </h5>
                </b-col>
              </b-row>
              <b-row>
                <b-col lg="6">
                  <h5>Click Rate</h5>
                </b-col>
                <b-col lg="6">
                  <h5>
                    {{
                      as_percentage(
                        campaign.campaign_report.CampaignHeader.clicks_pc
                      )
                    }}
                  </h5>
                </b-col>
              </b-row>
            </b-col>
            <b-col lg="6">
              <EmailStatsChart />
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
    <b-row>
      <b-col lg="12">
        <b-card>
          <b-row>
            <b-col lg="6">
              <h2>Social Media</h2>
              <h3>Impressions</h3>
              <b-row class="mt-2">
                <b-col lg="6">
                  <h5>Social Media</h5>
                </b-col>
                <b-col lg="6">
                  <h5>
                    {{
                      with_comma(
                        campaign.campaign_report.CampaignHeader
                          .MultiMediaAggregates.SM_Impressions
                      )
                    }}
                  </h5>
                </b-col>
              </b-row>

              <b-row>
                <b-col lg="6">
                  <h5>Targeted Display Ad</h5>
                </b-col>
                <b-col lg="6">
                  <h5>
                    {{
                      with_comma(
                        campaign.campaign_report.CampaignHeader
                          .MultiMediaAggregates.TDA_Impressions
                      )
                    }}
                  </h5>
                </b-col>
              </b-row>
              <b-row>
                <b-col lg="6">
                  <h5><span style="font-weight: 600">Total</span></h5>
                </b-col>
                <b-col lg="6">
                  <h5>
                    <span style="font-weight: 600">
                      {{ with_comma(total_mm_impressions) }}
                    </span>
                  </h5>
                </b-col>
              </b-row>

              <hr />
              <hr />
              <h3>Clicks</h3>
              <b-row>
                <b-col lg="6">
                  <h5>Social Media</h5>
                </b-col>
                <b-col lg="6">
                  <h5>
                    {{
                      with_comma(
                        campaign.campaign_report.CampaignHeader
                          .MultiMediaAggregates.SM_Clicks
                      )
                    }}
                  </h5>
                </b-col>
              </b-row>
              <b-row>
                <b-col lg="6">
                  <h5>Targeted Display Ad</h5>
                </b-col>
                <b-col lg="6">
                  <h5>
                    {{
                      with_comma(
                        campaign.campaign_report.CampaignHeader
                          .MultiMediaAggregates.TDA_Clicks
                      )
                    }}
                  </h5>
                </b-col>
              </b-row>
              <b-row>
                <b-col lg="6">
                  <h5><span style="font-weight: 600">Total</span></h5>
                </b-col>
                <b-col lg="6">
                  <h5>
                    <span style="font-weight: 600">
                      {{
                        with_comma(
                          campaign.campaign_report.CampaignHeader
                            .MultiMediaAggregates.SM_TDA_Clicks
                        )
                      }}</span
                    >
                  </h5>
                </b-col>
              </b-row>
              <hr />
              <hr />
              <h3>Engagement Rates</h3>
              <b-row>
                <b-col lg="6">
                  <h5>Social Media</h5>
                </b-col>
                <b-col lg="6">
                  <h5>
                    {{
                      as_percentage(
                        campaign.campaign_report.CampaignHeader
                          .MultiMediaAggregates.SM_ClickRate
                      )
                    }}
                  </h5>
                </b-col>
              </b-row>
              <b-row>
                <b-col lg="6">
                  <h5>Targeted Ad</h5>
                </b-col>
                <b-col lg="6">
                  <h5>
                    {{
                      as_percentage(
                        campaign.campaign_report.CampaignHeader
                          .MultiMediaAggregates.TDA_ClickRate
                      )
                    }}
                  </h5>
                </b-col>
              </b-row>
              <b-row>
                <b-col lg="6">
                  <h5><span style="font-weight: 600">Overall</span></h5>
                </b-col>
                <b-col lg="6">
                  <h5>
                    <span style="font-weight: 600">
                      {{
                        as_percentage(
                          campaign.campaign_report.CampaignHeader
                            .MultiMediaAggregates.Overall_ClickRate
                        )
                      }}</span
                    >
                  </h5>
                </b-col>
              </b-row>
            </b-col>
            <b-col lg="6">
              <b-row>
                <b-col lg="12">
                  <div>
                    <MultiMediaStatsChart id="stats_chart" />
                  </div>
                </b-col>
              </b-row>
              <b-row>
                <b-col lg="12">
                  <div>
                    <MMClicksPie id="clicks_chart" />
                  </div>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { CoolSelect } from "vue-cool-select";
import EmailStatsChart from "@/charts/EmailStatsChart.vue";
import MultiMediaStatsChart from "@/charts/MultiMediaStatsChart.vue";
import MMClicksPie from "@/charts/MMClicksPie.vue";

export default {
  name: "CampaignReport",
  data() {
    return {
      selected: [], // Must be an array reference!
      dirtyFields: [],
      show: true,
      seen: true,
      isSaving: false,
      isSaved: false,
      dismissSecs: 3,
      dismissCountDown: 0,
      dismiss2Secs: 3,
      dismiss2CountDown: 0,
      dismiss3Secs: 3,
      dismiss3CountDown: 0,
      showDismissibleAlert: false,
      percentageOptions: {
        style: "percent",
        minimumFractionDigits: 0,
        maximumFractionDigits: 2
      },
      isMatchBackFileCreated: false,
      matchBackFileLink: "",
      matchBackFileName: ""
    };
  },
  methods: {
    async createMatchBackFile() {
      await this.$store
        .dispatch(
          "campaign/generateMatchBackFile",
          this.$store.state.campaign.campaign_report.CampaignHeader.PONumber
        )
        .then(response => {
          //console.log(response.data["CreateMatchExportResult"]);

          this.matchBackFileName = response.data["CreateMatchExportResult"];
          this.matchBackFileLink =
            "https://api.boostdealersolutions.com/SystemLogs/Reports/" +
            this.matchBackFileName;
          this.isMatchBackFileCreated = true;
        });
    },

    loadOtherReport(reportID) {
      if (reportID == 1) {
        this.$router.push({ name: "CampaignReport" });
      }
      if (reportID == 2) {
        this.$router.push({ name: "CampaignROI" });
      }
      if (reportID == 3) {
        this.$router.push({ name: "CampaignVisual" });
      }
    },
    async myLoadComponent() {
      await this.$store.dispatch(
        "campaign/loadCampaignROI",
        this.$store.state.campaign.campaign_report.CampaignHeader.PONumber
      );
    },
    back() {
      this.$router.go(-1);
    },
    as_percentage(number) {
      return new Intl.NumberFormat(undefined, this.percentageOptions).format(
        number
      );
    },
    with_comma(number) {
      return new Intl.NumberFormat().format(number);
    },
    toggleVisibility() {
      this.seen = !this.seen;
    },
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown;
    },
    countDown2Changed(dismiss2CountDown) {
      this.dismiss2CountDown = dismiss2CountDown;
    },
    countDown3Changed(dismiss3CountDown) {
      this.dismiss3CountDown = dismiss3CountDown;
    },
    showAlert() {
      this.dismissCountDown = this.dismissSecs;
    },

    async save() {
      if (
        this.$store.state.dealer.dealers.find(
          dealer =>
            dealer.DealershipID !==
              this.$store.state.dealer.dealer_edit.DealershipID &&
            dealer.Name.toLowerCase() ===
              this.$store.state.dealer.dealer_edit.Name.toLowerCase() &&
            dealer.InternalDealerID.toLowerCase() ===
              this.$store.state.dealer.dealer_edit.InternalDealerID.toLowerCase()
        )
      ) {
        this.dismiss3CountDown = this.dismiss3Secs;
        return;
      }

      //double check the database
      // if (this.$store.state.dealer.dealer_edit.UserProfileID === -1) {
      //   var _existing_id = -1;

      //   await this.$store
      //     .dispatch(
      //       "dealer/doesDealerExist",
      //       this.$store.state.dealer.dealer_edit.Name
      //     )
      //     .then(response => {
      //       _existing_id = response.data["DoesDealerExistResult"];
      //     });

      //   if (_existing_id > -1) {
      //     this.dismiss3CountDown = this.dismiss3Secs;
      //     return;
      //   }
      // }

      this.$v.$touch();
      if (this.$v.$error) {
        this.dismiss2CountDown = this.dismiss2Secs;
      } else {
        this.$store.state.saveOp.localUrl = "/Dealer/Save/";
        this.$store.state.saveOp.localVariableName = "_d";
        this.$store.state.saveOp.localVariableObject = this.$store.state.dealer.dealer_edit;
        this.$store.state.saveOp.localDirtyFields = this.dirtyFields;
        this.$store.state.saveOp.localFieldToSet = "DealershipID";
        this.$store.state.saveOp.localReturnObject = "SaveDealerResult";

        this.$store
          .dispatch("saveOp/BuildSaveOperation")
          .then(
            this.$store
              .dispatch("saveOp/EmitSave")
              .then(
                (this.dirtyFields = []),
                (this.dismissCountDown = this.dismissSecs),
                this.$store.state.saveOp.DestroySaveOperation
              )
          );

        // this.$store
        //   .dispatch("saveOp/BuildSaveOperation")
        //   .then(this.$store.dispatch.dispatch("saveOp/EmitSave"))
        //   .then(
        //     (this.dirtyFields = [])((this.dismissCountDown = this.dismissSecs))
        //   );
      }
    },
    addDirtyField: function(event) {
      if (event.which !== 9 && event.which !== 13) {
        this.dirtyFields = this.dirtyFields.filter(
          dirtyField => dirtyField.FieldName !== event.target.id
        );
        this.dirtyFields.push({
          FieldName: event.target.id,
          FieldValue: event.target.value
        });
      }
    },
    addDirtyFieldWatch: function(field, newValue) {
      this.dirtyFields = this.dirtyFields.filter(
        dirtyField => dirtyField.FieldName !== field
      );
      this.dirtyFields.push({
        FieldName: field,
        FieldValue: newValue
      });
      this.$store.state.saveOp.localDirtyFields = this.dirtyFields;
    },
    addDirtyFieldRadio: function(event) {
      this.dirtyFields = this.dirtyFields.filter(
        dirtyField => dirtyField.FieldName !== event.target.name
      );
      this.dirtyFields.push({
        FieldName: event.target.name,
        FieldValue: event.target.value
      });
    },
    addDirtyFieldRadioWithCast: function(event) {
      this.dirtyFields = this.dirtyFields.filter(
        dirtyField => dirtyField.FieldName !== event.target.name
      );
      this.dirtyFields.push({
        FieldName: event.target.name,
        FieldValue: event.target.value
      });
      if (event.target.value == "true") {
        this.$store.state.dealer.dealer_edit.IsBoost = true;
      } else {
        this.$store.state.dealer.dealer_edit.IsBoost = false;
      }
    },
    addDirtyFieldSwitch: function(event) {
      this.dirtyFields = this.dirtyFields.filter(
        dirtyField => dirtyField.FieldName !== event.target.id
      );
      this.dirtyFields.push({
        FieldName: event.target.id,
        FieldValue: event.target.checked.toString()
      });
      this.$store.state.saveOp.localDirtyFields = this.dirtyFields;
    },
    togglePassword: function() {
      const passwordField = document.querySelector("#Password");
      if (passwordField.getAttribute("type") === "password") {
        passwordField.setAttribute("type", "text");
      } else {
        passwordField.setAttribute("type", "password");
      }
    },
    DashRouteTo(_page) {
      this.save();
      this.$router.push(_page);
    }
  },
  computed: {
    ...mapState(["campaign", "dealer", "n_user", "saveOp"]),
    ...mapActions("saveOp", ["Save", "EmitSave"]),
    isClean() {
      return this.dirtyFields.length === 0;
    },

    total_opens_impressions() {
      return (
        this.$store.state.campaign.campaign_report.CampaignHeader.opens +
        this.$store.state.campaign.campaign_report.CampaignHeader
          .MultiMediaAggregates.SM_Impressions +
        this.$store.state.campaign.campaign_report.CampaignHeader
          .MultiMediaAggregates.TDA_Impressions
      );
    },
    total_mm_impressions() {
      return (
        this.$store.state.campaign.campaign_report.CampaignHeader
          .MultiMediaAggregates.SM_Impressions +
        this.$store.state.campaign.campaign_report.CampaignHeader
          .MultiMediaAggregates.TDA_Impressions
      );
    }
  },
  components: {
    EmailStatsChart,
    MultiMediaStatsChart,
    MMClicksPie
  },
  mounted() {
    this.myLoadComponent();
  },

  watch: {}
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.input-group-text {
  color: #111;
}
.testred {
  color: red;
  border-color: red;
}
.btn-link:disabled,
.btn-link.disabled {
  color: #000;
  font-weight: bold;
  pointer-events: none;
  text-decoration: underline;
}
</style>
